import {useTranslation} from "react-i18next";
import React, {useContext, useState} from "react";
import {GlobalContext} from "../../utils/context/GlobalContextProvider.jsx";
import Badge from "../../components/Badge.jsx";
import Button from "../../components/Button.jsx";
import {fas} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useNavigate} from "react-router-dom";
import IdentityImage from "../../components/IdentityImage.jsx";
import DeleteProjectYesNo from "../project/DeleteProjectYesNo.jsx";
import wbrUuid from "../../utils/wbrUuid.js";
import PlanName from "../project/Subscription/PlanName.jsx";
import ActionButton from "../../components/ActionButton.jsx";

export function UserProjectListHeader() {
    let {t} = useTranslation();

    return (
        <tr>
            <th className="col-avatar">
                {/* logo */}
            </th>
            <th className="col-project">
                {t('project.name')}
            </th>
            <th className="col-actions">
                {t('actions')}
            </th>
        </tr>
    );
}

export default function UserProjectItem({project, onProjectIdSelected}) {

    let {t} = useTranslation();
    let {context} = useContext(GlobalContext);

    let navigate = useNavigate();

    let tdClassName = 'px-2 last:pr-5 py-3';

    let [deletePressed, setDeletePressed] = useState(false);

    const subscription = project?.subscription?.currentPackage?.name ?? 'free';

    const svgSize = 14;

    return (
        <tr className="project-item">
            <td className="col-avatar">
                <div
                    className="cursor-pointer"
                    onClick={() => onProjectIdSelected(project.id)}
                >
                    <IdentityImage
                        url={project.logoUrl}
                        project={project}
                    />
                </div>
            </td>
            <td className="col-project">
                <div className="text-left">
                    <div
                        className={'gap-4 font-bold cursor-pointer'}
                        onClick={() => onProjectIdSelected(project.id)}
                    >
                        {project.name}
                    </div>
                    <div className="flex gap-1">
                        <PlanName
                            planName={subscription}
                            className={'px-1.5 py-0.4 inline-flex items-center rounded-md bg-gray-50 text-xs font-medium text-gray-600 ring-1 ring-gray-500/10 ring-inset dark:bg-transparent dark:text-gray-300 dark:ring-gray-600'}
                        />
                        {
                            context.currentProjectId === project.id
                            && <span className={'px-1.5 py-0.4 inline-flex items-center rounded-md bg-green-50 text-xs font-medium text-green-700 ring-1 ring-green-600/20 ring-inset dark:bg-transparent dark:text-green-400 dark:ring-green-700'}>{t('projects.currently-selected')}</span>
                        }
                    </div>
                </div>
            </td>
            <td className="col-actions">
                <DeleteProjectYesNo
                    visible={deletePressed}
                    setVisible={setDeletePressed}
                    project={project}
                />

                <div className="flex gap-0.5 justify-end">

                    {context.currentProjectId !== project.id &&
                        <ActionButton
                            icon={'check'}
                            title={t('project.select')}
                            onClick={() => onProjectIdSelected(project.id)}
                        />
                    }

                    <ActionButton
                        icon={'pencil'}
                        title={t('route.project-settings')}
                        onClick={() => navigate('/project/' + project.id + '/settings')}
                    />

                    <ActionButton
                        icon={'trash'}
                        variant={'primary-red'}
                        title={t('project.delete')}
                        onClick={() => setDeletePressed(true)}
                    />
                </div>
            </td>
        </tr>
    );
}
